import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { Map } from 'immutable';

import { setAlertOptions } from './actionCreator';

import { getIsFetching } from '../App/selectors';

class Alert extends Component {
	constructor(props) {
		super(props);

		this.getContent = this.getContent.bind(this);
		this.getLoading = this.getLoading.bind(this);
		this.confirmAction = this.confirmAction.bind(this);
	}

	getLoading = () => {
		const { t } = this.props;
		return (
			<div className="alert alert-loading">
				<p>{t('alert.loading')}</p>
			</div>
		);
	};

	getContent = () => {
		const { alertConfig } = this.props;
		const alertClass = alertConfig.mode === "result" ? alertConfig.data && alertConfig.data.ok ? " alert-success" : " alert-danger" : " alert-normal";

		return (
			<div className={"alert" + alertClass}>
				{alertConfig.mode === "option" ?
					<div>
						<h4 className="text-uppercase alert-heading">{alertConfig.data.title}</h4>
						<button className="close" onClick={() => this.props.setAlertOptions({}, true)}>
							<span>&times;</span>
						</button>
					</div> : ""
				}
				<p>{alertConfig.data.description}</p>
				{alertConfig.mode === "option" ?
					<div>
						<button className="btn btn-sm btn-block btn-primary my-2" onClick={() => this.confirmAction()}>{alertConfig.data.confirmLabel}</button>
						{/* <button className="btn btn-sm btn-outline-secondary my-2" onClick={() => this.props.setAlertOptions({})}>RICOMINCIA DA CAPO</button> */}
					</div> : ""
				}
			</div>
		);
	};

	confirmAction = () => {
		const { alertConfig } = this.props;

		alertConfig.data.confirmAction();
		this.props.setAlertOptions({});
	};

	render() {
		const { isFetching, alertConfig } = this.props;

		return !isFetching ?
			alertConfig.mode ?
				this.getContent() : "" : this.getLoading()
		;
	}
}

const mapStateToProps = (state) => {
	return {
		isFetching: getIsFetching(state),
		alertConfig: state.getIn(['alert', 'alertConfig'], new Map())
	};
};

const mapDispatchToProps = {
	setAlertOptions
};

Alert.propTypes = {
	isFetching: PropTypes.bool.isRequired,
	alertConfig: PropTypes.object.isRequired,
	setAlertOptions: PropTypes.func.isRequired,
	t: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(Alert);
